import {AuthService} from "./AuthService";

export class SellerWorkspaceService {
    url = `seller_workspace/`;

    getSummary() {
        return AuthService.apiGet(this.url + "summary/").then(res => res.data.data);
    }

    getSellers(params) {
        const query = new URLSearchParams();
        Object.entries(params || {}).forEach(([name, value]) => {
            if (value !== null && value !== undefined && value !== '') query.set(name, value);
        });
        return AuthService.apiGet(this.url + "sellers/?" + query.toString()).then(res => res.data.data);
    }

    getSeller(storeId, campaignId) {
        const query = campaignId ? "?campaign_id=" + encodeURIComponent(campaignId) : "";
        return AuthService.apiGet(this.url + "sellers/" + encodeURIComponent(storeId) + "/" + query).then(res => res.data.data);
    }

    getSteps() {
        return AuthService.apiGet(this.url + "steps/").then(res => res.data.data);
    }

    getMonths() {
        return AuthService.apiGet(this.url + "months/").then(res => res.data.data);
    }

    exportMonth(month, labels) {
        return AuthService.apiPost(this.url + "export/", {month, labels}, {responseType: 'blob'});
    }

    runStep(step, scope, storeId) {
        return AuthService.apiPost(this.url + "run_step/", {step, scope, store_id: storeId}).then(res => res.data);
    }
}
